/**
 * Colour bands for the deal analysis score. Shared so the table cell and the
 * answer renderer can never disagree about what a 6 looks like.
 */
export function dealScoreTone(score: number | null): {
  text: string;
  fill: string;
  badge: string;
} {
  if (score === null || score >= 7) {
    return {
      text: "text-emerald-600 dark:text-emerald-400",
      fill: "bg-emerald-500",
      badge:
        "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
    };
  }

  if (score >= 4) {
    return {
      text: "text-amber-600 dark:text-amber-400",
      fill: "bg-amber-500",
      badge:
        "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300",
    };
  }

  return {
    text: "text-rose-600 dark:text-rose-400",
    fill: "bg-rose-500",
    badge: "bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-300",
  };
}
